import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Grid, Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';
import { get } from 'lodash';
import InputField from '../../../Common/InputField';
import SelectDropdown from '../../../Common/SelectDropdown';
import FullScreenLoader from '../../Loader/FullScreenLoader';
import {
  postRequest,
  putRequest,
  getRequest,
} from '../../interceptor/interceptor';
import { ADD_EDIT_USER, GET_ROLES } from '../../../apiConst';
import { setUser } from '../../../redux/actions/login.action';
import { userFields } from '../../../Fields/userFields';
import BackButton from '../../../Common/BackButton';

const AddUser = () => {
  const userData = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState(null);
  // const [toggle,setToggle] = useState(true)
  const [isEdit, setIsEdit] = useState(false);
  const [userRolesList, setUserRolesList] = useState([]);
  const [projectsList, setProjectsList] = useState([]);
  const [disableRole, setDisableRole] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    // Fetch user role and project data initially
    fetchUserRoleData();

    // Check if we're in edit mode based on location state
    if (location?.state?.isEdit) {
      const { data } = location.state;
      console.log('data:', data);

      // Prepare the modified data object with the full name
      const modifiedData = {
        ...data,
        fullName: `${data.firstName || ''} ${data.lastName || ''}`.trim(),
      };

      // Set edit state and other fields
      setIsEdit(true);
      setId(modifiedData.userId);
      if (
        modifiedData?.role === 'Super-Admin' &&
        modifiedData?.email === userData?.email
      ) {
        setDisableRole(true);
      }

      // Set the form data with the modified data
      reset(modifiedData);
    }
  }, [location?.state]);

  useEffect(() => {
    console.log(
      '🚀 ~ file: index.jsx:81 ~ useEffect ~ userRolesList:',
      userRolesList
    );

    // If roles are fetched and in edit mode, set the role value
    if (userRolesList?.length > 0 && isEdit) {
      setValue('role', get(location, 'state.data.role'));
    }
  }, [userRolesList]);

  const fetchUserRoleData = async () => {
    try {
      const data = await getRequest(GET_ROLES);
      console.log('data', data);
      if (data) {
        const options = data.map(({ name }) => ({ label: name, value: name }));
        setUserRolesList(options);
      }
    } catch (err) {
      console.error('Failed to fetch user roles:', err);
    }
  };

  const onSubmit = async (data) => {
    console.log('data', data);
    setIsLoading(true);
    try {
      const { fullName, email, designation, role, userId } = data;
      const [firstName, lastName = ''] = fullName.trim().split(' ');

      const updatedValues = { email, role, firstName, lastName, designation };

      if (userId) {
        updatedValues.userId = userId;
      }
      const response = await postRequest(ADD_EDIT_USER, updatedValues);
      console.log('response', response);
      const updatedUser = response.data;
      if (isEdit && updatedUser.email === userData.email) {
        dispatch(setUser(updatedUser));
        navigate('/all-users');
      }
      toast.success(`User ${isEdit ? 'Updated' : 'Added'} Successfully`);
      navigate('/all-users');
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'An error occurred';
      console.error('errorMessage:', errorMessage);
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const onCancel = () => navigate(-1); // Navigate to the previous page

  return (
    <>
      
      <div className="flex flex-col">
        <div className="block rounded-lg bg-white p-6 shadow mt-4 ml-2 mr-2 overflow-auto">
          <BackButton onClick={() => navigate(-1)} />
          <h1 className="flex mb-6 text-2xl font-extrabold text-gray-700">
            {isEdit ? 'Edit' : 'Add'} User
          </h1>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2} marginBottom={1}>
              {userFields.map(
                ({ fieldTitle, fieldName, fieldType, validationObj }) => (
                  <Grid
                    item
                    xs={12}
                    sm={fieldName === 'project' ? 12 : 6}
                    key={fieldName}
                  >
                    <div className="flex flex-col mb-6 w-full">
                      <label className="block text-gray-800 font-bold mb-3 pr-4">
                        {fieldTitle}
                      </label>
                      <div className="flex w-full">
                        {fieldType === 'select' && fieldName === 'role' ? (
                          <SelectDropdown
                            fieldName={fieldName}
                            options={userRolesList}
                            register={register}
                            validationObj={validationObj}
                            errors={errors}
                            fieldType={fieldType}
                            disabled={fieldName === 'role' && disableRole}
                            // val={
                            //   isEdit &&
                            //   fieldName === 'role' &&
                            //   get(location, 'state.data.role')
                            // }
                          />
                        ) : fieldType === 'select' && fieldName !== 'role' ? (
                          <SelectDropdown
                            fieldName={fieldName}
                            options={projectsList}
                            register={register}
                            validationObj={validationObj}
                            errors={errors}
                            fieldType={fieldType}
                            multiple={fieldName === 'project'}
                            // value={isEdit && fieldName === 'role' ? get(location, 'state.data.role') : ''}
                          />
                        ) : (
                          <InputField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            errors={errors}
                            fieldType={fieldType}
                            placeholder={fieldTitle}
                            disabled={fieldName === 'password' && isEdit}
                          />
                        )}
                      </div>
                    </div>
                  </Grid>
                )
              )}
              {/* <Grid item xs={12} sm={3}>
                  <div className="toggle mt-5 mb-5">
                    <label className="name">Un Licensed</label>
                    <input
                      type="checkbox"
                      className="checkbox"
                      id={`checkbox`}
                      checked={toggle}
                      onChange={() => setToggle(!toggle)}
                    />
                    <label htmlFor={`checkbox`} className="label">
                      <div className="ball"></div>
                    </label>
                    <label className="name">Licensed</label>
                  </div>
                </Grid> */}
            </Grid>
            <div className="flex justify-center space-x-4">
              <Button
                variant="contained"
                color="error"
                onClick={onCancel}
                className="mt-2"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                className="mt-2"
              >
                {isEdit ? 'Update' : 'Submit'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddUser;
